import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Checkbox,
  Input,
  MultiSelect,
} from '@roger/ui-components';
import { EDGE_OPTIONS } from '../../../constants/wounds';
import type { EdgesState } from '../assessmentFormTypes';

interface EdgesSectionProps {
  state: EdgesState;
  onChange: (update: Partial<EdgesState>) => void;
}

const EdgesSection: React.FC<EdgesSectionProps> = ({ state, onChange }) => (
  <AccordionItem value='edges' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Edges
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-2'>
        <Checkbox
          id='edges-na'
          checked={state.notAssessed}
          onCheckedChange={v =>
            onChange({ notAssessed: !!v, ...(!v && { notAssessedReason: '' }) })
          }
        />
        <label htmlFor='edges-na' className='text-sm cursor-pointer'>
          Not Assessed
        </label>
      </div>
      {state.notAssessed && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {!state.notAssessed && (
        <MultiSelect
          options={EDGE_OPTIONS}
          value={state.values}
          onChange={v => onChange({ values: v })}
        />
      )}
    </AccordionContent>
  </AccordionItem>
);

export default EdgesSection;
